<template>
  <BootstrapModal class="EditWebsiteMenu"
    v-on="$listeners"

    @save="saveProductGroup"
  >
    <FormInput
      class="form-element"
      v-model="$v.name.$model"

      id="size"
      label="Size"

      :vuelidate="$v"
      fieldName="name"
    />

    <template #title>
      {{ size ? "Edit Size" : "Add Size" }}
    </template>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"

import FormInput from "src/components/Inputs/FormInput.vue"

import { required } from "vuelidate/lib/validators"

export default {
  props: ["size", "callback"],
  components: {
    BootstrapModal,
    FormInput,
  },
  validations: {
    name: {
      required,
    },
  },
  data() {
    return {
      name: "",
    }
  },
  created() {
    if (this.size) {
      this.$v.name.$model = this.size.name
    }
  },
  methods: {
    saveProductGroup() {
      this.$v.$touch()
      if (this.$v.$error) return;

      const payload = {
        name: this.$v.name.$model,
      }

      this.$handlePromise(async () => {
        if (this.size) {
          await this.axios.put(`/api/sizes/${this.size.uid}`, payload)
        } else {
          await this.axios.post(`/api/sizes`, payload)
        }
        this.$store.dispatch('clearCacheSearch', "sizes")

        this.$success("Size succesvol opgeslagen!")
        this.callback && this.callback()
        this.$emit("close")
      })
    },
  },
}

</script>

<style scoped>

.EditWebsiteMenu {
  flex-basis: 500px;
}

</style>
